import { getRouterInstance } from '@/Infrastructure/Routing/routerInstance';
import { useSyncExternalStore } from 'react';

/** Module scoped so useSyncExternalStore sees a stable subscribe function and does not resubscribe every render
 * .subscribe() is declared as @private and an update to React.Router could break this but the package itself is built 
 * around this logic so it is generally safe. 
 */
const subscribe = (onChange: () => void) => getRouterInstance().subscribe(onChange);

/**
 * Value of a single search parameter, re-rendering only when that value changes rather than on every navigation
 * as useSearchParams does (e.g. opening the consignment modal).
 */
export default function useSearchParameter(key: string) {
	return useSyncExternalStore(subscribe, () => new URLSearchParams(getRouterInstance().state.location.search).get(key));
}
